module.exports = __webpack_public_path__ + "img/ehouse-sema.f935ec54.png";